module.exports = __webpack_public_path__ + "e0e0aa5e520110b8c3c5d67abf9bdd3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/jogo-do-bicho/loterias.png
// module id = 1040
// module chunks = 0